import { ArrowLeft, GitCommit, CheckCircle2 } from 'lucide-react';

interface ChangelogProps {
  onBack: () => void;
}

export function Changelog({ onBack }: ChangelogProps) {
  const changes = [
    {
      version: '1.0.2',
      date: '2026-02-15',
      changes: [
        'Added Polygon Mainnet support for real HABL token minting.',
        'Fixed prayer completion logic to ensure coins are minted and heatmap is updated.',
        'Improved invite system error messages for easier troubleshooting.',
        'Fixed blockchain sync issues where coins were not saving correctly.',
        'Polished Footprint chart: corrected start date, spacing, and labels.'
      ]
    },
    {
      version: '1.0.1',
      date: '2026-02-14',
      changes: [
        'Added 5 daily prayers with audio guidance.',
        'Fixed audio synchronization for Surah recitation.',
        'Added visual progress bars for silent prayer steps.',
        'Enabled background audio for mobile devices.'
      ]
    },
    {
      version: '1.0.0',
      date: '2026-02-01',
      changes: [
        'Initial release of Habl.Life.',
        'Quran reader, Zakat calculator, and Qibla compass.',
        'Personal blockchain ledger for tracking good deeds.',
        'Mini Masjid for family and friends circles.'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900 text-white p-6 pt-safe-top">
      <div className="flex items-center gap-4 mb-8">
        <button 
          onClick={onBack}
          className="p-2 -ml-2 rounded-full hover:bg-slate-800 text-slate-400 transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h2 className="text-xl font-bold font-mono text-emerald-400">Changelog</h2>
      </div>

      <div className="space-y-8 relative before:absolute before:left-2.5 before:top-2 before:h-full before:w-0.5 before:bg-slate-800">
        {changes.map((release, idx) => (
          <div key={idx} className="relative pl-8">
            <div className="absolute left-0 top-1.5 w-5 h-5 bg-slate-900 border-2 border-emerald-500 rounded-full flex items-center justify-center z-10">
                <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
            </div>
            
            <div className="mb-2">
                <span className="text-emerald-400 font-mono font-bold text-lg">v{release.version}</span>
                <span className="text-slate-500 text-xs ml-3 font-mono">{release.date}</span>
            </div>
            
            <div className="bg-slate-800/50 rounded-xl p-4 border border-slate-700/50">
                <ul className="space-y-3">
                    {release.changes.map((change, cIdx) => (
                        <li key={cIdx} className="flex items-start gap-3 text-sm text-slate-300">
                            <CheckCircle2 className="w-4 h-4 text-emerald-500/50 mt-0.5 flex-shrink-0" />
                            <span className="leading-relaxed">{change}</span>
                        </li>
                    ))}
                </ul>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-12 text-center">
        <p className="text-xs text-slate-600 font-mono">
            Deployed on Polygon Mainnet
        </p>
        <div className="flex justify-center gap-2 mt-2">
            <GitCommit className="w-4 h-4 text-slate-700" />
            <span className="text-[10px] text-slate-700 font-mono">Commit: {Math.random().toString(16).substring(2, 10)}</span>
        </div>
      </div>
    </div>
  );
}
